import SchemaFilterForm from 'admin/components/shared/SchemaFilterForm';
import Textbox from 'admin/components/shared/Textbox';
import { toQueryParams } from 'admin/utils';
import React, { Component } from 'react';
import CSSModules from 'react-css-modules';
import Button from '../../../atoms/Buttons';
import DateTimeRange from '../../../atoms/DateTimeRange';
import styles from './styles.scss';

class FilterForm extends Component {
  constructor(props) {
    super(props);
    this.state = {
      customer_id: '',
      customer_tel: '',
      customer_email: '',
      customer_name: '',
      registered_from: null,
      registered_to: null,
      user_attribute_queries: {},
    };
  }

  onSubmit = (e) => {
    e.preventDefault();
    this.setState({ customer_tel: this.state.customer_tel.trim() }, () => {
      const params = {
        private_money_id: this.props.selectedMoney.id,
        customer_id: this.state.customer_id,
        customer_tel: this.state.customer_tel,
        customer_email: this.state.customer_email,
        customer_name: this.state.customer_name,
        registered_from: this.state.registered_from,
        registered_to: this.state.registered_to,
        user_attribute_queries: this.state.user_attribute_queries,
      };
      this.props.onFilterSubmit(toQueryParams(params));
    });
  };

  onClear = () => {
    this.setState({
      customer_id: '',
      customer_tel: '',
      customer_email: '',
      customer_name: '',
      registered_from: null,
      registered_to: null,
      user_attribute_queries: {},
    });
  };

  onChangeQuery = (key, value) => {
    const userAttributeQueries = Object.assign({}, this.state.user_attribute_queries);
    userAttributeQueries[key] = value;
    this.setState({ user_attribute_queries: userAttributeQueries });
  };

  render() {
    return (
      <form styleName="date-range-picker" autoComplete="off">
        <div styleName="form-group">
          <label styleName="label" htmlFor="customer_id">
            お客様ID
          </label>
          <Textbox
            name="customer_id"
            id="customer_id"
            value={this.state.customer_id}
            onChange={(e) => this.setState({ customer_id: e.target.value })}
            styleName="textbox"
          />
        </div>
        <div styleName="form-group">
          <label styleName="label" htmlFor="customer_tel">
            携帯電話番号
          </label>
          <Textbox
            name="customer_tel"
            id="customer_tel"
            value={this.state.customer_tel}
            onChange={(e) => this.setState({ customer_tel: e.target.value })}
            styleName="textbox"
          />
        </div>
        <div styleName="form-group">
          <label styleName="label" htmlFor="customer_email">
            メールアドレス
          </label>
          <Textbox
            name="customer_email"
            id="customer_email"
            value={this.state.customer_email}
            onChange={(e) => this.setState({ customer_email: e.target.value })}
            styleName="textbox"
          />
        </div>
        <div styleName="form-group">
          <label styleName="label" htmlFor="customer_name">
            ニックネーム
          </label>
          <Textbox
            name="customer_name"
            id="customer_name"
            value={this.state.customer_name}
            onChange={(e) => this.setState({ customer_name: e.target.value })}
            styleName="textbox"
          />
        </div>
        <div styleName="form-group">
          <label styleName="label" htmlFor="registered_from">
            会員登録日時
          </label>
          <DateTimeRange
            wrapperStyles={{ display: 'inline-flex' }}
            dateRange={{
              from: this.state.registered_from,
              to: this.state.registered_to,
            }}
            dateTimeProps={{
              fromProps: {
                inputProps: { id: 'registered_from', name: 'registered_from' },
                showIcon: true,
              },
              toProps: {
                inputProps: { id: 'registered_to', name: 'registered_to' },
                showIcon: true,
              },
            }}
            setDateRange={({ from, to }) =>
              this.setState({ registered_from: from, registered_to: to })
            }
          />
        </div>
        {this.props.isMoneySelected ? (
          <SchemaFilterForm
            onChangeQuery={this.onChangeQuery}
            selectedMoney={this.props.selectedMoney}
            isClear={Object.keys(this.state.user_attribute_queries).length === 0}
          />
        ) : null}
        <div styleName="form-group">
          <Button
            variant="neutral"
            style={{ marginLeft: '10px' }}
            type="button"
            onClick={this.onClear}
            disabled={!this.props.isMoneySelected}
          >
            クリア
          </Button>
          <Button
            onClick={this.onSubmit}
            disabled={!this.props.isMoneySelected}
            style={{ marginLeft: '10px' }}
          >
            検索
          </Button>
        </div>
      </form>
    );
  }
}

export default CSSModules(FilterForm, styles);
